import { IcepackCustomModalCell } from './components/icepack-custom-modal-cell';

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';

export const ICEPACK_FORM_NAME = 'icepack-form';

export const ICEPACK_TABLE_COLUMNS_NAMES = [{ id: 'title' }, { id: 'value', customComponent: IcepackCustomModalCell }];

export const ICEPACK_TABLE_ROWS_NAMES = {
	partner: 'Производитель',
	sizes: 'Внешние геометрические размеры',
	weight: 'Масса пустого',
	volume: 'Объем',
	package_quantity: 'Кол-во в групповой упаковке',
	pallet_quantity: 'Кол-во на паллете',
	author: 'Автор',
};

export const REQUIRED_FIELDS = [
	'name',
	'partner_id',
	'length',
	'width',
	'height',
	'weight',
	'volume',
	'package_quantity',
];

export const FIELDS_FOR_VALIDATE = [
	'name',
	'partner_id',
	'length',
	'width',
	'height',
	'weight',
	'volume',
	'package_quantity',
	'pallet_quantity',
];
